import { AI_STATUS, GENDER_ALL } from '@/consts';
import BaseEntity from '@/entities/BaseEntity';
import ContentGenerationItemPublication from '@/entities/ContentGenerationItemPublication';

export default class ContentGenerationItem extends BaseEntity {
  id = null;
  owner = null;
  status = AI_STATUS.WAITING;
  content_goal = null;
  content_length = 'standard';
  language = null;
  industry = null;
  tone = null;
  website = null;
  description = '';
  target_audience_gender = GENDER_ALL;
  target_audience_age_min = 18;
  target_audience_age_max = 65;
  visual_format = '4:5';
  visual_font_family = 'Inter';
  visual_font_weight = '900';
  visual_text = '';
  visual_logo_size = 100;
  content = null;
  visual_idea = null;
  visual_prompt = null;
  logo = null;
  reference_image = null;
  image = null;
  publications = [];
  created_at = new Date();
  updated_at = new Date();

  _entityArrayFields = {
    publications: ContentGenerationItemPublication,
  };

  constructor(rawData) {
    super();

    if (rawData && rawData.created_at) {
      rawData.created_at = new Date(rawData.created_at);
    }
    if (rawData && rawData.updated_at) {
      rawData.updated_at = new Date(rawData.updated_at);
    }

    this.updateWith(rawData);
  }

  get isWaiting() {
    return this.status === AI_STATUS.WAITING;
  }

  get isInProgress() {
    return this.status === AI_STATUS.IN_PROGRESS;
  }

  get isCompleted() {
    return this.status === AI_STATUS.DONE;
  }

  get hasError() {
    return this.status === AI_STATUS.ERROR;
  }

  get hasResult() {
    return this.isCompleted && this.content !== null;
  }

  get shortDescription() {
    if (!this.description) {
      return '';
    }

    const lengthLimit = 120;
    let text = this.description.replace(/(?:\r\n|\r|\n)/g, ' ');

    if (text.length < lengthLimit) {
      return text;
    }

    text = text.slice(0, lengthLimit);
    const lastSpaceIndex = text.lastIndexOf(' ');
    text = text.slice(0, lastSpaceIndex);
    text += '...';

    return text;
  }
}
